import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

    public errorMessage: string = '';
    public errorType: string = '';
  
    constructor() { }
}
